export const GET_FUEL_RECORD = "GET_FUEL_RECORD";
